import { render, staticRenderFns } from "./FilePicker.vue?vue&type=template&id=22d8f773&scoped=true"
import script from "./FilePicker.vue?vue&type=script&lang=js"
export * from "./FilePicker.vue?vue&type=script&lang=js"
import style0 from "./FilePicker.vue?vue&type=style&index=0&id=22d8f773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8f773",
  null
  
)

export default component.exports